import { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faList } from '@fortawesome/free-solid-svg-icons';
import { czyRozliczenieWodyWmAkt } from "../../../functions/woda";
import WodaOdczytyRazemDodajOkres from "./WodaOdczytyRazemDodajOkres";
import WodaOdczytyRazemSzczegoly from "./WodaOdczytyRazemSzczegoly";
import WodaOdczytyRazemSzczegolyEdytuj from "./WodaOdczytyRazemSzczegolyEdytuj";
import WodaOdczytyUdzialyProcenty from "../UdziałyProcenty/WodaOdczytyUdzialyProcenty";
import WodaOdczytyRazemListaOkresow from "./WodaOdczytyRazemListaOkresow";
import Tooltip from '@mui/material/Tooltip';
import Snackbar from '@mui/material/Snackbar';
import DialogOk from '../../DialogOk';

const WodaOdczytyRazem = props => {

    const { odczyty, odczytyWm, wybranaWspolnota, ulice, lokale, udzialyKontaAkt, grupy, mieszkancy, setTrashId, setOpen, czyWybranaWspolnota, rozliczenieWody, wybranyZakres, setWybranyZakres,
        wybraneRozliczenie, setWybraneRozliczenie, rozliczenieWodyWmSaved
     } = props;

    // console.log(wybraneRozliczenie)

    const [showDodajOkres, setShowDodajOkres] = useState(false);
    const [showPokazOkresy, setShowPokazOkresy] = useState(true);
    
    const [edytowanyZakres, setEdytowanyZakres] = useState(undefined);
    const [edit, setEdit] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [message, setMessage] = useState("");
    const [rozliczenieWodyWmSavedAkt, setRozliczenieWodyWmSavedAkt] = useState([]);
    const [czyWmSavedAkt, setCzyWmSavedAkt] = useState(false);

    useEffect( () => setRozliczenieWodyWmSavedAkt( rozliczenieWodyWmSaved?.find( r => r?.id_odczytu_wm == wybraneRozliczenie?.id) ), [rozliczenieWodyWmSaved, wybraneRozliczenie, czyRozliczenieWodyWmAkt]);
    useEffect( () => setCzyWmSavedAkt( czyRozliczenieWodyWmAkt(wybraneRozliczenie, rozliczenieWodyWmSavedAkt) ), [wybraneRozliczenie, rozliczenieWodyWmSavedAkt]);

    const handleZakres = d => {
        setShowDodajOkres(false);
        setWybranyZakres(d);
        setEdytowanyZakres(d);
    }

    useEffect( () => {
        setWybranyZakres(undefined);
        setEdytowanyZakres(undefined);
    }, [odczytyWm]);

    useEffect( () => {
        if (wybranyZakres?.id > 0) {
            setWybraneRozliczenie( rozliczenieWody?.find( r => r?.id == wybranyZakres.id) );
        }
        setEdit(false);
    },[wybranyZakres, rozliczenieWody, wybranaWspolnota, odczyty, odczytyWm]);

    const handleDodajOkres = () => {
        if (!czyWybranaWspolnota)
            handleOpen(); 
        else {
            setShowDodajOkres( prevState => !prevState);
            setShowPokazOkresy(false);
            setWybranyZakres(undefined);
            setEdytowanyZakres(undefined);
            setWybraneRozliczenie(undefined)
        }
    }
    
    const handleRemove = (id) => {
        setTrashId(id);
        setOpen(true);        
    }
    
    const handlePokazOkresy = () => {
        if (!czyWybranaWspolnota)
            handleOpen();
        else {
            setShowPokazOkresy(true);
            setShowDodajOkres(false);
            setWybranyZakres(undefined);
            setEdytowanyZakres(undefined);
            setWybraneRozliczenie(undefined)
        }
    }

    useEffect( () => {
        if (!czyWybranaWspolnota) 
            setWybraneRozliczenie(undefined)
    },[]);

    const [snackBar, setSnackBar] = useState({tresc: 'Wybierz wspólnotę', open: false, vertical: 'bottom', horizontal: 'left'});

    const { tresc, open, vertical, horizontal  } = snackBar;

    const handleOpen = () => setSnackBar(prev => ({...prev, open: true}));
    const handleClose = () => setSnackBar(prev => ({...prev, open: false}));

    // console.log(rozliczenieWodyWmSaved);
    // console.log(rozliczenieWodyWmSavedAkt);
    // console.log(czyWmSavedAkt)

    return (
        <div className="woda-content-razem">
            <div className="woda-odczyty-lista">
                <div className="lista-naglowek">
                    <p>Okresy rozliczeniowe</p>
                    <Tooltip
                        title={"Pokaż listę okresów"}
                        placement='top'
                    >
                        <FontAwesomeIcon 
                            icon={faList} 
                            className='pointer g'
                            onClick={handlePokazOkresy}
                        />
                    </Tooltip>
                    <Tooltip
                        title={"Dodaj nowy okres"}
                        placement='top'
                    >
                        <FontAwesomeIcon 
                            icon={faPlus} 
                            className='pointer'
                            onClick={handleDodajOkres}
                        />
                    </Tooltip>
                </div>
                {  
                    showDodajOkres && ( 
                        <WodaOdczytyRazemDodajOkres
                            wybranaWspolnota={wybranaWspolnota}
                            setShowDodajOkres={setShowDodajOkres}
                            setOpenDialog={setOpenDialog}
                            setMessage={setMessage}
                            handlePokazOkresy={handlePokazOkresy}
                        />
                    )
                }
                {
                    showPokazOkresy && (
                        <WodaOdczytyRazemListaOkresow
                            odczytyWm={odczytyWm}
                            wybranyZakres={wybranyZakres}
                            handleZakres={handleZakres}
                            handleRemove={handleRemove}
                        />
                    )
                }
            </div>
            {
                wybraneRozliczenie && (
                    <div className="woda-dane">
                        {
                            edit ? (
                                <WodaOdczytyRazemSzczegolyEdytuj
                                    setEdit={setEdit}
                                    edytowanyZakres={edytowanyZakres}
                                    setEdytowanyZakres={setEdytowanyZakres}
                                    setOpenDialog={setOpenDialog}
                                    setMessage={setMessage}
                                />
                            ) : (
                                <WodaOdczytyRazemSzczegoly
                                    wybraneRozliczenie={wybraneRozliczenie}
                                    setEdit={setEdit}
                                    edytowanyZakres={edytowanyZakres}
                                    wybranyZakres={wybranyZakres}
                                    czyWmSavedAkt={czyWmSavedAkt}
                                />
                            )
                        }
                        <WodaOdczytyUdzialyProcenty
                            wybraneRozliczenie={wybraneRozliczenie}
                            ulice={ulice}
                            lokale={lokale}
                            udzialyKontaAkt={udzialyKontaAkt}
                            grupy={grupy}
                            mieszkancy={mieszkancy}
                            wybranyZakres={wybranyZakres}
                        />
                    </div>
                )
            }
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={open}
                onClose={handleClose}
                message={tresc}
                key={vertical + horizontal}
            />
            <DialogOk
                open={openDialog}
                setOpen={setOpenDialog}
                message={message}
            />
        </div>
    )
}

export default WodaOdczytyRazem;